import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/alumni-workshops-website/alumni-workshops-website/src/components/workshop-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Introduction to Redis`}</h1>
    <h2>{`2022-04-14 at 6:00pm`}</h2>
    <p><em parentName="p">{`Duration: 1 hour`}</em></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=20220415T010000Z%2F20220415T020000Z&details=In%20this%20session%2C%20you%27ll%20get%20a%20practical%20introduction%20to%20Redis%2C%20a%20common%20distributed%20in-memory%20data%20store.%20By%20the%20end%20of%20the%20session%2C%20you%27ll%20be%20able%20to%20answer%20questions%20like%3A%20what%20is%20Redis%3F%20What%20kinds%20of%20problems%20does%20Redis%20solve%3F&location=http%3A%2F%2Flovelace-labs.adadev.org&text=Introduction%20to%20Redis%20with%20Dan%20Roberts"
        }}>{`Add To Google Calendar`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://outlook.live.com/calendar/0/deeplink/compose?allday=false&body=In%20this%20session%2C%20you%27ll%20get%20a%20practical%20introduction%20to%20Redis%2C%20a%20common%20distributed%20in-memory%20data%20store.%20By%20the%20end%20of%20the%20session%2C%20you%27ll%20be%20able%20to%20answer%20questions%20like%3A%20what%20is%20Redis%3F%20What%20kinds%20of%20problems%20does%20Redis%20solve%3F&enddt=2022-04-15T02%3A00%3A00%2B00%3A00&location=http%3A%2F%2Flovelace-labs.adadev.org&path=%2Fcalendar%2Faction%2Fcompose&rru=addevent&startdt=2022-04-15T01%3A00%3A00%2B00%3A00&subject=Introduction%20to%20Redis%20with%20Dan%20Roberts"
        }}>{`Add to Microsoft Calendar`}</a></li>
    </ul>
    <p>{`This session will serve as a practical introduction to Redis, a common distributed in-memory data store. By the end of the session, students will be able to answer questions like:`}</p>
    <ul>
      <li parentName="ul">{`What is Redis?`}</li>
      <li parentName="ul">{`How can I explain what it does to my non-technical manager / PM in a way they'll understand?`}</li>
      <li parentName="ul">{`What kinds of problems does Redis solve?`}</li>
      <li parentName="ul">{`What shouldn't you use Redis for?`}</li>
      <li parentName="ul">{`How should I deploy Redis in my environment?`}</li>
    </ul>
    <p>{`We'll also go through a couple of case studies that concretely demonstrate common problems solved by Redis.`}</p>
    <h2>{`Dan Roberts`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "300px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/7a653117db5cee206ada827cbd4158f0/5a46d/dan-roberts-thumb.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "100%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFYUlEQVQ4y03SaVAUZBjA8a1mGjpQUicxMkUFDTQlBARFJRBBRINEUEBZEpdzOZZjF9hd5FBWBEEBwyni2l1g2QOWBUSnbDzDKMtKmMbSMmYSxysrC/XfLDZO78zz4f3ym/c/zysoL8ihQimlqriQ6jIlyqwUQlYv53U7G2bZPo/DFBvmTX8Zt7kzWfe2E1F+7gg3+LBigQNBnktoa6hjwGigT99Fv0mPoLwg+z+wgJoyBUWSFNwWODDD5hlm273A/Bkv4zF/Fqtd57DZ24W4IC8yIgN4d+VSHO1sSIoM5ZjJQJ/hf+ABZR6Ve2TUlheRHBvB3Gk2uDpMxcXellXOs4j2W0ZO5DqK4zZSIQpDtSsUYcDbeDu/hjDYC1NbIwPdJvqNT1+YR2WRlPr9xURu8MPB9lnWurxGjK8LDemRnD6czxXdYcb7G7l/ysDf580cTt9GmM+bZGz1p6X+IMd7zfQZu6yghApl7lMwNiwIhynPEblyEft2rudcTS7XOqonZ9z8IQ++OA5XvuKCpgbZjg2IIwJQH63juLn7f6DiCVinKkIUHc5C+5dICfGgLiWc4bpCxnS1/KKpYmJoAH4ZgfFr3DjdQ/JmX8rEsVi62idz+6zJ+/Kz2C/P4UBRHof2yslO3InL63ZErVqEKiGU7tJkflRX8segmlHDUYa1tYx2N3HF0kpCkBflme8zaDZi0XdiMegQ7JVloiq0LiaX6pICCtMTnnwPf3ckEWvJ3baerLDVNObEo5XFcSh1K8M9Wk7pWzGopFw3qbHo2yfB3q5OBKXSdJ5k53CwJJ/8tHhEwd4oRFuoEW9lf/J2dgV4cOFoGSPaaka1h/h75Dx3vz3Lzb4W7gzoMXWqsXR1YNZ1ICjJTWNvfiYqeTZVe6TIxLvYvtYN8SZvjqRFIItYQ2bwcm71NvFgaIA7g1r+/G6I28OfcEt/hMvmLvQdbfTqtJh17Qj25KRQKhWzryCLiqJcpKlCwvw9SQr2RCuJoTTKD3nYSu4fb+fxhWNMnDHD9R+493k/o5Z2ujs1GNtb6OlU09OpQaDISqQ4N5Wy/HRUimxyk3cQFuhD6pZ3GCgVcUAYzP6YQO4NtvPwmzP8fs7CP5dOMn6un87GI3SpP54ETR1tmDrUCAozdqPMTqI4L429hZlIRNGEB3qTFRdGryoVeZQ/dUnh3D/Tw9igjqs9TTy8fJq7F0+ib65H19qIQdOEUduCUduKwLqEwowEFJJESmTpSEQxvBe4goKMBD6QxqGKD0G+2ZefW2u4fczAxE/f8df3Z3j88/ec6m5Ee7Qag7YNg7oJo6YFgTQlDnnm7sls6yREheDv4cQ6T2c2ejsj3e6PRhLLteZqHn57jj9Hh7n95Qm4c4OvP9XRUZ6IvrkBg6YNvboZQbYohqToTWxdv4JAT2eWOtrh4fQKS2a/RNT65cQHeaBVJvObpZmbJ3sYO3uMe5dOweNHfN77IRplJNp9Ino+qsCobkLg7z4PD6dpuM+zw91xKkvesMXnzVcn7+IdmygUhqCIDWZYXcO1EzrGPjPy6OZ1Hjz4C32VGINqF82KaJrk0XTXyxB4OU/H19WeALfZrHKdiZsVnv8K/kvtSdu5kT5tLQ1SIRc7D/Hrp+2MjwxhPedPmKjPCqW7MpGPCqKoEr9Lg2wbgjVLZuG31IE1i+2x4l7OM3hrzouEui8jPvg9qnOKqZeXUJOZQpEwlbGrN5mY+IdKSewk2KVKoKVoJ+WJIaiSNz4BfRfb4+k0jWWOU1nmOIWFDs/jt8AXkU8eofPCCZy7gQW2jrjauHKi+SwjF4coFq6jWbGdJmuuMpba7C0cSN3Ev4Pi3nHi4M/hAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Dan Roberts thumbnail",
            "title": "Dan Roberts thumbnail",
            "src": "/static/7a653117db5cee206ada827cbd4158f0/5a46d/dan-roberts-thumb.png",
            "srcSet": ["/static/7a653117db5cee206ada827cbd4158f0/5a46d/dan-roberts-thumb.png 300w"],
            "sizes": "(max-width: 300px) 100vw, 300px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <p>{`Dan Roberts is a former lead instructor at Ada Developers Academy. He currently works as a Senior Software Engineer at `}<a parentName="p" {...{
        "href": "https://www.remitly.com/"
      }}>{`Remitly`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      